import React from "react"
import Section from "src/components/Section"
import Grid, { Container } from "src/components/Grid"
import TextLockup from "src/components/TextLockup"
import styled from "@emotion/styled"
import { mq, globals } from "src/styles"

const Wrapper = styled(Section)`
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const TwoColumnText = ({
  className,
  theme,
  spacing,
  nextTheme,
  prevTheme,
  isFirstSection,
  headingSize,
  leftText,
  _rawRightText,
  actions,
  id,
  hideMobile,
  hideDesktop,
}) => {
  const rightText = _rawRightText

  return (
    <Wrapper
      className={className}
      setTheme={theme}
      prevTheme={prevTheme}
      nextTheme={nextTheme}
      isFirstSection={isFirstSection}
      id={id}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <Container medium="1 [12] 1">
        <Grid
          small="[1]"
          medium="[4] 1 [7]"
          large="[5] 1 [6]"
          extraLarge="[5] 1 [5] 1"
          vAlign="top"
          rowGap="1em"
        >
          <div>
            <TextLockup
              headline={leftText}
              theme={theme}
              headingSize={headingSize}
              headlineElement="h3"
            />
          </div>
          <div>
            <TextLockup text={rightText} theme={theme} actions={actions} />
          </div>
        </Grid>
      </Container>
    </Wrapper>
  )
}

export default TwoColumnText
